export default {
  API_HOST: process.env.REACT_APP_API_HOST,
  BASE_NAME: process.env.REACT_APP_BASE_NAME,
  UTPA_EMAIL: process.env.REACT_APP_UTPA_EMAIL,
  UTPA_PHONE: process.env.REACT_APP_UTPA_PHONE,
};



// WEBPACK FOOTER //
// ./src/config.js